import { ColDef, ColumnApi, FirstDataRenderedEvent, GridApi, GridReadyEvent, GridSizeChangedEvent, SortChangedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { DetailReportWrapper } from "./styles";

interface IProps {
    title: string,
    data: any[],
    totals: any,
    columns: ColDef[]
}

const ClcDetailsGrid = (props: IProps) => {
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null);

    const onGridReady = (e: GridReadyEvent) => {
        setGridApi(e.api);
        setColumnApi(e.columnApi);

        e.api.sizeColumnsToFit();
    };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {

    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    };

    return (
        <div style={{ marginBottom: 20 }}>
            <h4>{props.title}</h4>

            <DetailReportWrapper id='grid-wrapper' className='ag-theme-bootstrap' style={{ height: props.data.length >= 15 ? 430 : null }}>
                <AgGridReact
                    enableCellTextSelection={true}
                    enableRangeSelection={true}
                    columnDefs={props.columns}
                    rowData={props.data}
                    headerHeight={30}
                    noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                    suppressCellSelection={true}
                    domLayout={props.data.length < 15 ? 'autoHeight' : null}
                    onGridReady={onGridReady}
                    onGridSizeChanged={onGridSizeChanged}
                    onFirstDataRendered={onFirstDataRendered}
                    onSortChanged={onSortChanged}
                    pinnedBottomRowData={[props.totals]}
                    getRowStyle={(props: any) => {
                        if (props.data.isTotal) {
                            return { backgroundColor: '#d9edf7' }
                        }

                        return null;
                    }}
                />
            </DetailReportWrapper>
        </div>
    );
}

export default ClcDetailsGrid;